import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { postRequest, getRequest } from "../services";

// Async thunk for sending notifications
export const sendNotification = createAsyncThunk(
  "notifications/send",
  async (notificationData, { rejectWithValue }) => {
    try {
      const response = await postRequest("/api/Notifications/send", notificationData);
      return response.data;
    } catch (error) {
      if (error.data?.errors) {
        const errorMessages = Object.values(error.data.errors).flat().join(", ");
        return rejectWithValue(errorMessages);
      }
      return rejectWithValue(error.message || "Failed to send notification");
    }
  }
);

export const sendEmailNotification = createAsyncThunk(
  "notifications/sendEmail",
  async (emailData, { rejectWithValue }) => {
    try {
      const response = await postRequest("/api/Notifications/send-email", emailData);
      return response.data;
    } catch (error) {
      if (error.data?.errors) {
        const errorMessages = Object.values(error.data.errors).flat().join(", ");
        return rejectWithValue(errorMessages);
      }
      return rejectWithValue(error.message || "Failed to send email notification");
    }
  }
);

// Async thunk for fetching notifications (if you need it)
export const fetchNotifications = createAsyncThunk(
  "notifications/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getRequest("/api/Notifications");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to fetch notifications");
    }
  }
);

const notificationsSlice = createSlice({
  name: "notifications",
  initialState: {
    notifications: [],
    loading: false,
    error: null,
    sendStatus: "idle", // 'idle', 'loading', 'succeeded', 'failed'
  },
  reducers: {
    clearNotificationStatus: (state) => {
      state.sendStatus = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Send notification cases
      .addCase(sendNotification.pending, (state) => {
        state.sendStatus = "loading";
      })
      .addCase(sendNotification.fulfilled, (state) => {
        state.sendStatus = "succeeded";
        state.error = null;
      })
      .addCase(sendNotification.rejected, (state, action) => {
        state.sendStatus = "failed";
        state.error = action.payload;
      })
      .addCase(sendEmailNotification.rejected, (state, action) => {
        state.error = action.payload;
      })
      // Fetch notifications cases (if implemented)
      .addCase(fetchNotifications.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchNotifications.fulfilled, (state, action) => {
        state.loading = false;
        state.notifications = action.payload;
        state.error = null;
      })
      .addCase(fetchNotifications.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearNotificationStatus } = notificationsSlice.actions;
export default notificationsSlice.reducer;